import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { useRecordContext } from 'react-admin';
import { formatDate } from '../utils/utils';

const TrainerLicenseField = (props) => {
    const trainer = useRecordContext();

    if (trainer?.hasLicense === true) {
        return (
            <Tooltip title={`From ${formatDate(trainer.licenseStartDate)} until ${formatDate(trainer.licenseEndDate)}`}>
                <Chip label='Active' color='info' size='small' {...props} />
            </Tooltip>
        );
    }

    if (trainer?.licenseEndDate != null) {
        return (
            <Tooltip title={`Since ${formatDate(trainer.licenseEndDate)}`}>
                <Chip label='Inactive' color='default' size='small' {...props} />
            </Tooltip>
        );
    }

    return <Chip label='Inactive' color='default' size='small' {...props} />;
};

export default TrainerLicenseField;
